module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui stackable four column middle aligned centered grid"
  }, [_c('div', {
    staticClass: "four wide column",
    staticStyle: {
      "margin-top": "180px"
    }
  }, [_c('div', {
    staticClass: "ui raised padded segment"
  }, [_c('h2', {
    staticClass: "ui center aligned padded secondary header"
  }, [_vm._v("\n            Meine Insel Booking\n        ")]), _vm._v(" "), _c('form', {
    staticClass: "ui huge form",
    class: [{
      'error': _vm.error != ''
    }],
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.email),
      expression: "loginData.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "E-mail address"
    },
    domProps: {
      "value": (_vm.loginData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginData.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.loginData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginData.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui fluid big primary submit button",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Login")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaffccc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Login.vue
// module id = 751
// module chunks = 1